export default __webpack_public_path__ + "static/media/transit.23353546.svg";